export const getMFEUrl = (mfeName) => System.resolve(mfeName);

export const getBaseUrl = (mfeName) => getMFEUrl(mfeName).replace(new RegExp('(.*/)[^/]+$'), '$1');

export const getShellAppConfigUrl = (mfeName) => getMFEUrl(mfeName);

export const getMFEConfigUrl = (mfeName) => {
  const mfeUrl = getMFEUrl(mfeName);
  // const lastSlashPosition = mfeUrl.lastIndexOf('/');
  // const configUrl = mfeUrl.slice(0, lastSlashPosition) + '/conf' + mfeUrl.slice(lastSlashPosition);

  // return configUrl;
  return mfeUrl;
};

export const getConfigFromJson = async (configUrl) => {
  try {
    const response = await fetch(getMFEConfigUrl(configUrl));
    if (!response.ok) {
      throw new Error(`Response status: ${response.status}`);
    }

    const json = await response.json();
    return json;
  } catch (error) {
    throw new Error(`An error occurred while getting the configuration file: ${error}`);
  }
};
